/**
 * 预结算
 */
import React, { useImperativeHandle, memo, useState } from 'react';
import { connect } from 'react-redux';

import PreSettle from '@/pages/bill/preSettle';
import { initOrderMaster } from '@/redux/actions/bill';
import { getPortal } from '@/components/PortalContext';

export interface PreSettleDrawerRef {
  // 主单号 回调
  showDrawer: (orderNo: string, callback?: () => void) => void;
}

interface IProps {
  myRef?: React.Ref<PreSettleDrawerRef>;
  callGetMasterInfo: (params: { resvNo: string }) => void;
}

// 预结算portal
let settlePortalId: string;

const PortalComponent = ({ orderNo }) => {
  const [visible, setVisible] = useState(true);
  return (
    <PreSettle resvNo={orderNo} drawerVisible={visible} togglePreSettleDrawerVisible={setVisible} />
  );
};

const Index: React.FC<IProps> = (props) => {
  const { callGetMasterInfo, myRef } = props;

  useImperativeHandle(
    myRef,
    () => ({
      showDrawer: (orderNo, callback) => {
        callback();
        callGetMasterInfo({ resvNo: orderNo });
        if (settlePortalId) {
          getPortal().removePortalNode(settlePortalId);
        }
        settlePortalId = getPortal().renderPortalNode(() => <PortalComponent orderNo={orderNo} />);
      },
    }),
    [],
  );

  return null;
};

const mapStateToProps = () => {
  return {};
};
const mapDispatchToProps = {
  callGetMasterInfo: initOrderMaster,
};

const WithRedux = connect(mapStateToProps, mapDispatchToProps)(memo(Index));

export default React.forwardRef<PreSettleDrawerRef>((props, ref) => (
  <WithRedux {...props} myRef={ref} />
));
